import { useSuspenseQueries } from '@tanstack/react-query';
import { FrontendStartupWithSimulation } from '../../context/contexts';
import { Role } from '../types';
import { FrontendStartupService } from './service';

// TODO Refactor the errorhandling parts
export const useFrontendStartup = (
  debugString: string,
  frontendStartupService: FrontendStartupService,
  simulatedRole: Role | null
) => {
  // Execute queries in parallel - using any[] to avoid complex TypeScript type issues
  const simulationEnabled = simulatedRole !== null;
  const results = useSuspenseQueries({
    queries: [
      {
        queryKey: ['frontend-startup', ...frontendStartupService.getDeps()],
        queryFn: () => {
          console.debug(`[useQuery] ${debugString}`, [
            'frontend-startup',
            ...frontendStartupService.getDeps(),
          ]);
          return frontendStartupService.get();
        },
      },
      {
        queryKey: [
          'frontend-startup-for-simulation',
          simulatedRole?.id,
          ...frontendStartupService.getDeps(),
        ],
        queryFn: simulationEnabled
          ? () => {
              console.debug(`[useQuery] ${debugString}`, [
                'frontend-startup-for-simulation',
                simulatedRole?.id,
                ...frontendStartupService.getDeps(),
              ]);
              return frontendStartupService.getForSimulation(
                simulatedRole ??
                  (() => {
                    throw new Error(
                      'simulatedRole is null but must be set for getForSimulation'
                    );
                  })()
              );
            }
          : () => Promise.resolve(null),
      },
    ],
  });
  const [frontendStartupResult, frontendStartupForSimulationResult] = results;
  const error =
    frontendStartupResult.error || frontendStartupForSimulationResult.error;

  // We need to handle the case where data might be null or undefined
  if (!frontendStartupResult.data) {
    return {
      data: null,
      error,
      rawResults: results,
    };
  }

  // At this point TypeScript knows frontendStartupResult.data is not null
  const frontendStartup = frontendStartupResult.data;
  const frontendStartupForSimulation =
    frontendStartupForSimulationResult.data ?? null;

  const frontendStartupData: FrontendStartupWithSimulation = {
    get roleDetails() {
      if (frontendStartupForSimulation?.simulatedRole) {
        return frontendStartupForSimulation.simulatedRole;
      }
      if (
        !frontendStartup.currentUser ||
        !frontendStartup.currentUser.userRole
      ) {
        throw new Error('User role details not available');
      }
      return frontendStartup.currentUser.userRole;
    },
    get originalRoleDetails() {
      if (
        !frontendStartup.currentUser ||
        !frontendStartup.currentUser.userRole
      ) {
        throw new Error('Original user role details not available');
      }
      return frontendStartup.currentUser.userRole;
    },
    get dashboards() {
      if (frontendStartupForSimulation?.listAllDashboards) {
        return frontendStartupForSimulation.listAllDashboards;
      }
      return frontendStartup.listAllDashboards;
    },
    get currentUser() {
      if (frontendStartup.currentUser) {
        return frontendStartup.currentUser;
      } else {
        throw new Error('Current user not available');
      }
    },
  };

  return {
    data: frontendStartupData,
    error,
    rawResults: results,
  };
};
